import * as React from "react";
import { MedicalTypeId } from "@teamprevent/common/healthSurveillance";
import { Label } from "semantic-ui-react";

import { MEDICAL_TYPE_ID } from "../models";

interface Props {
    medicalTypeId: MedicalTypeId;
    medicalTypeName: string;
}

const DraggableMedicalType: React.FunctionComponent<Props> = (props) => {
    const onDragStart = React.useCallback((event: React.DragEvent<HTMLElement>) => {
        event.dataTransfer.setData(MEDICAL_TYPE_ID, props.medicalTypeId);
    }, [props.medicalTypeId]);

    return (
        <Label className="draggable-medical-type" content={props.medicalTypeName} draggable onDragStart={onDragStart}  />
    );
};

export { DraggableMedicalType };
